import { render, staticRenderFns } from "./StudyTasks.vue?vue&type=template&id=3369b250&"
import script from "./StudyTasks.vue?vue&type=script&lang=js&"
export * from "./StudyTasks.vue?vue&type=script&lang=js&"
import style0 from "./StudyTasks.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports